
export enum TransBnkCode {
    ICIC = 'ICIC', // ICICI Bank Ltd
    INDB = 'INDB', // IndusInd Bank Ltd
    HSBC = 'HSBC', // HSBC Bank
    KKBK = 'KKBK', // Kotak Mahindra Bank Ltd
    HDFC = 'HDFC', // HDFC Bank Ltd
    UTIB = 'UTIB', // Axis Bank Ltd
    RATN = 'RATN', // TRANSBNK RBL Bank
    YESB = 'YESB', // TRANSBNK Yes Bank
};


export enum BankUserAuthorizationStatus {
    REQUEST_TO_BE_SENT = 'REQUEST_TO_BE_SENT',
    // RESPONSE_AWAITED = 'RESPONSE_AWAITED',
    REQUEST_FAILED = 'REQUEST_FAILED',
    PENDING = 'PENDING',
    GRANTED = 'GRANTED',
    REJECTED = 'REJECTED',
    REVOKED = 'REVOKED',
};


export enum ConnectedBankingStatus {
    REQUEST_TO_BE_SENT= 'REQUEST_TO_BE_SENT',
    REQUEST_FAILED = 'REQUEST_FAILED',
    PENDING = 'PENDING',
    GRANTED = 'GRANTED',
    REJECTED = 'REJECTED',
    REVOKED = 'REVOKED',
}